var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-5 rwd-padding text-center"},[_vm._t("title"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }